import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'VErrorBoundary',
  data: () => ({
    error: false
  }),
  errorCaptured (/*err, vm, info*/) {
    this.error = true
  },
  render(h): VNode {
    return this.error ? h('p', 'Something went wrong') : (this.$slots && this.$slots.default ? this.$slots.default[0] : '') as VNode;
  }
});